"use client";

import { Suspense } from "react";
import { usePathname } from "next/navigation";
import Navbar from "@/features/navbar/Navbar";
import Footer from "@/features/home/footer/Footer";
import ChatWidget from "@/components/shared/ChatWidget";

type SiteChromeProps = {
  children: React.ReactNode;
  logoUrl?: string;
  footerCms?: any;
};

// Routes that ship their own header/footer and must not be wrapped in the
// main site's Navbar/Footer/chat widget (e.g. standalone CRO landing pages).
const CHROMELESS_ROUTES = ["/start-free-trial"];

export default function SiteChrome({
  children,
  logoUrl,
  footerCms,
}: SiteChromeProps) {
  const pathname = usePathname();
  const isChromeless = CHROMELESS_ROUTES.some(
    (route) => pathname === route || pathname?.startsWith(`${route}/`),
  );

  if (isChromeless) {
    return (
      <>
        {children}
        <Footer cms={footerCms} />
      </>
    );
  }

  return (
    <>
      <Navbar logoUrl={logoUrl} />
      <main className="pb-16 lg:pb-0">{children}</main>
      <div className="cv-auto">
        <Suspense>
          <Footer cms={footerCms} />
        </Suspense>
      </div>
      <ChatWidget />
    </>
  );
}
